import styled from 'styled-components';

const StyledCheckBox = styled.div`
  margin-bottom: 10px;

  .form-check {
    padding-left: 0;
    background: url(${(props) => props.theme.forms.formControl.checkbox.unchecked.backgroundImage}) no-repeat top left;

    input {
      display: none;
    }
    .form-check-label {
      p {
        padding-left: 32px;
      }
    }
  }

  &.selected {
    .form-check {
      background-image: url(${(props) => props.theme.forms.formControl.checkbox.checked.backgroundImage});
    }
  }
  &.error {
    .form-check {
      background-image: url(${(props) => props.theme.forms.formControl.checkbox.error.backgroundImage});
    }
  }

  .error-label {
    margin-left: 32px;
  }
`;

export default StyledCheckBox;
